Drupal.behaviors.sw_chart = {
  attach: function( context, settings ) {
    $('.js-counter').once('sw_chart').chart('counter');
  }
};

$.fn.chart = function ( type ) {
	this.each( function () {
    if ( wow_instance.disabled() ) {
      return;
    }
		var chart = new Chart ( $(this), type );
		$(this).data('chart',chart);
	});
	return this;
};

var Chart = function ( $wrap, type ) {
	var _this = this;

	if ( !$wrap.length || $wrap.hasClass('chart-processed') ) {
		return;
	}

	this.type = type;

	this.$wrap = $wrap;

	this.$wrap.addClass('chart-processed');

	this.play_duration = 2000;
	this.play_easing = $.easing.easeOutCubic;
	this.play_step = 20;

	this.play_percent = 0;
	this.played = false;
	this.plaing = false;
	this.play_timer = null;
	this.value_current = 0;
	this.value = parseFloat(this.$wrap.data('value'));
	this.value = this.value ? this.value : 0;
	this.value_max = parseFloat(this.$wrap.data('value-max'));
	this.value_max = this.value_max ? this.value_max : 100;
	this.decimals = this.$wrap.data('decimals');
	this.decimals = this.decimals ? this.decimals : 0;

  this.$wrap.on('wow', function() {
    _this.play();
  });

  $(window).on('beforeprint', function() {
    _this.end();
  });

	this.reset();
};

Chart.prototype.play = function () {
	if ( this.played ) {
		return;
	}
	this.played = true;
	this.reset();
	this.plaing = true;
	this.step();
};

Chart.prototype.reset = function () {
	this.value_current = 0;
	this.play_percent = 0;
	this.plaing = false;
	this.step ();
	this.$wrap.html(this.value_current);
};

Chart.prototype.end = function() {
  this.play_percent = 1;
  this.step();
}

Chart.prototype.step = function () {
	var _this = this;

	this.value_current = this.value / this.value_max * 100 * this.play_easing ( this.play_percent, this.play_percent, 0, 1, 1 );

	if ( this.type === 'counter' ) {
		var val = Math.round(this.value_current/100*this.value_max * Math.pow(10,this.decimals) ) / Math.pow(10,this.decimals);
		val = val.toFixed(this.decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		this.$wrap.html(val);
	}

	if ( this.plaing ) {
		if ( this.play_percent < 1 ) {
			this.play_percent += this.play_step / this.play_duration;
			if ( this.play_percent > 1 ) {
				this.play_percent = 1;
			}
			this.play_timer = setTimeout(function () {
				_this.step();
			}, this.play_step );
		} else {
			this.plaing = false;
		}
	}
};
